import './style.scss';
import type { IJourney } from '../../../../../models/journey.model';
import type { ITripLeg } from '../../../../../models/trip-leg.model';
import JourneySummary from '../../../JourneySearchResults/JourneySummary';
import { TranslationService } from '../../../../../services/translation.service';
import { JourneyHelper } from '../../../../../helpers/journey.helper';
import ExpandableListItem from '../../../JourneySearchResults/ExpandableListItem';
import TripLegSelectorResultTripLeg from '../TripLegSelectorResultTripLeg';

function TripLegSelectorResultItem({ journey, index, onSelect }: { journey: IJourney; index: number; onSelect?: ((tripLeg: ITripLeg, index: number) => void) | undefined }) {
  return (
    <>
      {journey.tripLegs && journey.tripLegs.length > 1 && (
        <ExpandableListItem
          id={`result-item-${index}`}
          collapsedContent={<JourneySummary journey={journey} />}
          renderExpandedContent={() => (
            <>
              <ul className="pt-2">
                {journey.tripLegs?.map((tripLeg, tripLegIndex) => (
                  <li key={tripLeg.journeyLegIndex} className="py-2">
                    <TripLegSelectorResultTripLeg tripLeg={tripLeg} onSelect={() => onSelect?.(tripLeg, tripLegIndex)} />
                  </li>
                ))}
              </ul>
            </>
          )}
        ></ExpandableListItem>
      )}
      {journey.tripLegs && journey.tripLegs.length === 1 && (
        <li className={`trip-leg-selector-result-item pt-2 pb-2 px-3 pb-3 ${JourneyHelper.getTripLegIsCancelled(journey) || JourneyHelper.getTripLegIsPartCancelled(journey) ? 'bg-gray' : ''}`}>
          <div>
            <JourneySummary journey={journey} />
            <div className="d-flex justify-content-end mt-2">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  onSelect?.(journey.tripLegs![0], 0);
                }}
              >
                {TranslationService.get('common.selectandcontinue')}
              </button>
            </div>
          </div>
        </li>
      )}
    </>
  );
}

export default TripLegSelectorResultItem;
